/**
 * @file
 * Titan Basis Theme behaviors.
 */
(function (Drupal) {
  "use strict";

  Drupal.behaviors.titanBaseTheme = {
    attach(context, settings) {
      once("titan-base-theme-announce", "body", context).forEach((el) => {
        console.log("It works! TITAN BASE THEME");
      });
    },
  };
})(Drupal);
